import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import classnames from "classnames";
import { gettext } from "web/script/modules/django-i18n";
import PropTypes from "prop-types";
import React, { lazy, Suspense, useState } from "react";
import Button from "web/react/components/button/button";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import LoadingSpinner from "web/react/components/loading-spinner/loading-spinner";
import { usePrevious } from "web/react/hooks/use-previous/use-previous";
import styles from "./save-for-later.css";
var basePropTypes = {
  className: PropTypes.string,
  isSaved: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  cta: PropTypes.string,
  showExpressCheckout: PropTypes.bool,
  bingTraffic: PropTypes.bool
};
var HeartAnimation = lazy(function () {
  return import("web/react/components/lottie-animations/heart-animation/heart-animation");
});
export function SaveForLaterIcon(_ref) {
  var onClick = _ref.onClick,
      isSaved = _ref.isSaved,
      className = _ref.className,
      isSaving = _ref.isSaving;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAnimating = _useState2[0],
      setIsAnimating = _useState2[1];

  function loadAnimation() {
    // Dynamically import heart animation when user hovers...
    import("web/react/components/lottie-animations/heart-animation/heart-animation");
  }

  var previousIsSaved = usePrevious(isSaving);
  var showAnimation = !previousIsSaved && isSaving || isAnimating;
  return React.createElement("button", {
    onClick: onClick,
    className: classnames(styles.icon, className, _defineProperty({}, styles.iconSaved, isSaved)),
    onMouseEnter: loadAnimation
  }, !showAnimation && React.createElement(SVGIcon, {
    name: isSaved ? "heart-pressed" : "heart-unpressed",
    className: styles.svgIcon
  }), showAnimation && React.createElement(Suspense, {
    fallback: React.createElement(LoadingSpinner, null)
  }, React.createElement("div", {
    className: styles.animatedHeart
  }, React.createElement(HeartAnimation, {
    onComplete: function onComplete() {
      setIsAnimating(false);
    },
    onAnimationStart: function onAnimationStart() {
      setIsAnimating(true);
    }
  }))));
}
SaveForLaterIcon.propTypes = basePropTypes;

function getCTA(isSaved) {
  if (isSaved) {
    return gettext("in_stock_product.saved");
  } else {
    return gettext("save_for_later.cta.variant_b");
  }
}

export function SaveForLaterNormal(_ref2) {
  var onClick = _ref2.onClick,
      isSaved = _ref2.isSaved,
      isSaving = _ref2.isSaving,
      className = _ref2.className,
      cta = _ref2.cta,
      showExpressCheckout = _ref2.showExpressCheckout,
      bingTraffic = _ref2.bingTraffic;
  var buttonStyle = "secondary";

  if (showExpressCheckout && bingTraffic === false) {
    buttonStyle = "primary";
  }

  return React.createElement(Button, {
    styleType: isSaved ? "temp-grey" : buttonStyle,
    onClick: onClick,
    className: className,
    fullWidth: true,
    disabled: isSaving
  }, React.createElement(SVGIcon, {
    className: styles.svg,
    name: isSaved ? "heart" : "heart-empty"
  }), " ", React.createElement("span", null, cta ? cta : getCTA(isSaved)));
}
SaveForLaterNormal.propTypes = basePropTypes;
export function SaveForLaterStockAlert(_ref3) {
  var onClick = _ref3.onClick,
      isSaved = _ref3.isSaved,
      isSaving = _ref3.isSaving,
      className = _ref3.className,
      cta = _ref3.cta;
  var ctaText;

  if (isSaved) {
    ctaText = getCTA(isSaved);
  } else {
    ctaText = cta ? cta : getCTA(isSaved);
  }

  return React.createElement(Button, {
    styleType: isSaved ? "temp-grey" : "primary",
    onClick: onClick,
    className: className,
    disabled: isSaving
  }, React.createElement(SVGIcon, {
    className: styles.svg,
    name: "bell"
  }), " ", React.createElement("span", null, ctaText));
}
SaveForLaterStockAlert.propTypes = basePropTypes;
var BUTTON_TYPES = {
  icon: SaveForLaterIcon,
  normal: SaveForLaterNormal,
  stockAlert: SaveForLaterStockAlert
};

function SaveForLater(_ref4) {
  var type = _ref4.type,
      props = _objectWithoutProperties(_ref4, ["type"]);

  var Component = BUTTON_TYPES[type];

  if (!Component) {
    throw new Error("Invalid button type ".concat(type, "!"));
  }

  return React.createElement(Component, props);
}

export default SaveForLater;
SaveForLater.propTypes = _objectSpread({}, basePropTypes, {
  type: PropTypes.oneOf(["icon", "normal", "stockAlert"]).isRequired
});
SaveForLater.defaultProps = {
  isSaving: false
};